function loadItems(button) {
  const totalPages = parseInt(
    document.querySelector("[data-total-pages]").value,
    10
  );
  let currentPage = parseInt(
    document.querySelector("[data-current-page]").value,
    10
  );
  let currentPageScroll = currentPage + 1;

  currentPage = currentPage + 1;

  const rawValue = document.querySelector("[data-next-url]").value;

  const getUrlWithoutPhcursor = (value, pageValue) => {
    const url = new URL(value, window.location.origin);
    url.searchParams.set("page", pageValue);
    url.searchParams.delete("phcursor");
    return url.pathname + "?" + url.searchParams.toString();
  };

  const nextUrl = getUrlWithoutPhcursor(rawValue, currentPage);
  const nextUrlScroll = getUrlWithoutPhcursor(rawValue, currentPageScroll);

  document.querySelector("[data-current-page]").value = currentPage;

  button.setAttribute("disabled", "");
  button.classList.add("loading");

  // NORD CLS: místo pro novou stranu hned (do 500 ms od kliknutí se posun nepočítá), viz nbReserve
  const placeholders = nbReserve(currentPage);
  const isLastPage = currentPage >= totalPages;
  if (isLastPage) button.style.display = "none";
  let loaded = false;

  fetch(nextUrl)
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.text();
    })
    .then((responseHTML) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(responseHTML, "text/html");
      const newGrid = doc.querySelector(".load-more-grid");
      const wrapper = document.querySelector(".load-more-grid");
      if (!newGrid || !wrapper) {
        throw new Error("Grid element not found");
      }
      const newItems = newGrid.innerHTML;
      // výměna v jednom kroku: zástupné karty pryč a skutečné na jejich místo
      placeholders.forEach((placeholder) => placeholder.remove());
      wrapper.insertAdjacentHTML("beforeend", newItems);
      loaded = true;
      nbKeepScrollManual();

      if (doc.getElementById("LoadMoreProgress")) {
        updateProgressLabel(responseHTML);
        updateProgressbar(currentPage, totalPages);
      }
    })
    .catch((error) => {
      console.error("Error loading items:", error);
      placeholders.forEach((placeholder) => placeholder.remove());
      if (isLastPage) button.style.display = "";
      // strana se nenačetla → další klik ji zkusí znovu (dřív se přeskočila)
      document.querySelector("[data-current-page]").value = currentPage - 1;
      button.removeAttribute("disabled");
      button.classList.remove("loading");
    })
    .finally(() => {
      if (currentPage <= totalPages) {
        const scrollData = document.querySelector(".infinite-scroll__data");
        if (scrollData && currentPage !== totalPages) {
          const nextUrlInput = scrollData.querySelector("input[data-next-url]");
          const currentPageInput = scrollData.querySelector(
            "input[data-current-page]"
          );

          if (nextUrlInput) {
            nextUrlInput.dataset.nextUrl = nextUrlScroll;
            nextUrlInput.value = nextUrlScroll;
          }

          if (currentPageInput) {
            currentPageInput.dataset.currentPage = currentPage;
            currentPageInput.value = currentPage;
          }

          checkVisibility();
        }

        button.removeAttribute("disabled");
        button.classList.remove("loading");

        if (loaded && currentPage === totalPages) {
          button.remove();
        }
      }
    });
}

/*
 * NORD 12. 10. 2026: CLS kategorií (Search Console / Shopify Web performance).
 * „Zobrazit více“ vkládal karty až po načtení další strany (~0,5–1 s po kliknutí), takže lišta
 * výhod, newsletter a patička pod mřížkou poskočily dolů mimo 500ms okno po vstupu → CLS 0,57
 * (desktop) až 0,62 (mobil) za jedno kliknutí. Teď se ve stejném kroku jako kliknutí vloží
 * šedé zástupné karty se stejným počtem a výškou řádku; po načtení se vymění za skutečné.
 * Počet = velikost strany, u poslední strany jen zbytek (data-nb-* v snippets/load-more.liquid).
 */
function nbReserve(page) {
  const grid = document.querySelector(".load-more-grid");
  const meta = document.querySelector(".load-more-wrapper[data-nb-page-size]");
  const sample = grid && grid.lastElementChild;
  if (!grid || !meta || !sample) return [];
  const pageSize = parseInt(meta.dataset.nbPageSize, 10);
  const totalItems = parseInt(meta.dataset.nbTotalItems, 10);
  if (!(pageSize > 0) || !(totalItems > 0)) return [];
  const count = Math.min(pageSize, totalItems - (page - 1) * pageSize);
  const height = sample.offsetHeight;
  if (!(count > 0) || !(height > 0)) return [];

  const media = sample.querySelector(".product-card__media");
  const mediaHeight = media ? media.offsetHeight : height;
  const placeholders = [];
  for (let i = 0; i < count; i++) {
    const placeholder = document.createElement(sample.tagName);
    placeholder.className = sample.className + " nb-load-placeholder";
    placeholder.setAttribute("aria-hidden", "true");
    placeholder.style.height = height + "px";
    const block = document.createElement("div");
    block.style.height = mediaHeight + "px";
    block.style.background = "rgba(18, 18, 18, 0.05)";
    placeholder.appendChild(block);
    placeholders.push(placeholder);
  }
  grid.append(...placeholders);
  return placeholders;
}

/*
 * Po „Zobrazit více“ má záznam historie ruční obnovu posunu. Jinak by prohlížeč po návratu
 * Zpět skočil na staré místo ještě na kratší stránce (vidět patička) a dočtení stran níže
 * (restore) by ji odsunulo → CLS 1,0. Takhle stránka začne nahoře a na místo ji posune restore.
 */
function nbKeepScrollManual() {
  if ("scrollRestoration" in history) history.scrollRestoration = "manual";
}

function checkVisibility() {
  const spinnerList = document.querySelectorAll(".js-infinite-scroll");
  spinnerList.forEach((spinner) => {
    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadItems(spinner);
          sectionObserver.unobserve(entry.target);
        }
      });
    });

    sectionObserver.observe(spinner);
  });
}

function updateProgressLabel(html) {
  const count =
    new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("LoadMoreProgress")?.innerHTML || "";
  const container = document.getElementById("LoadMoreProgress");
  if (container) {
    container.innerHTML = count;
  }
}

function updateProgressbar(current, total) {
  const progressbar = document.getElementById("LoadMoreProgressBar");
  if (progressbar) {
    progressbar.style.width = `${(current / total) * 100}%`;
  }
}

function initLoadMore() {
  document.querySelectorAll(".js-load-more").forEach((button) => {
    button.onclick = () => {
      loadItems(button);
    };
  });

  checkVisibility();
}

(function () {
  initLoadMore();
})();

/*
 * NORD 12. 10. 2026: návrat z detailu produktu na stejné místo v kolekci.
 * „Načíst další“ jen připojuje karty a adresu nemění, takže krok Zpět načetl jen 1. stranu
 * a zákazník začínal znovu nahoře. Před odchodem ze stránky se do sessionStorage (jen tato
 * karta prohlížeče) uloží počet načtených stran a pozice; při návratu tlačítkem Zpět se strany
 * dočtou a stránka se posune na původní místo. Filtry a řazení drží adresa (facets.js pushState).
 */
(function () {
  const STATE_KEY = "nb-loadmore-state";
  const MAX_EXTRA_PAGES = 20; // strop dočítání: 20 stran × 12 karet
  const CONCURRENCY = 4; // souběžné požadavky, ať storefront nebrzdí
  const TTL_MS = 30 * 60 * 1000;

  /** Adresa výpisu bez stránkování — totožná pro uložení i návrat. */
  function listingKey() {
    const url = new URL(window.location.href);
    url.searchParams.delete("page");
    url.searchParams.delete("phcursor");
    return url.pathname + "?" + url.searchParams.toString();
  }

  /** Adresa konkrétní strany aktuálního výpisu. */
  function pageUrl(page) {
    const url = new URL(window.location.href);
    url.searchParams.set("page", page);
    url.searchParams.delete("phcursor");
    return url.pathname + "?" + url.searchParams.toString();
  }

  function readState() {
    try {
      return JSON.parse(sessionStorage.getItem(STATE_KEY) || "null");
    } catch (error) {
      console.warn("NORD load-more: stav nejde přečíst", error);
      return null;
    }
  }

  function saveState() {
    const pageInput = document.querySelector("[data-current-page]");
    if (!pageInput) return;
    try {
      // Strana vykreslená serverem = ?page= v adrese (Načíst další adresu nemění).
      // defaultValue použít nejde: u input[type=hidden] ho přepíše i změna value.
      const startPage =
        parseInt(new URL(window.location.href).searchParams.get("page"), 10) || 1;
      const pages = parseInt(pageInput.value, 10);
      if (!(pages > startPage)) {
        sessionStorage.removeItem(STATE_KEY);
        return;
      }
      sessionStorage.setItem(
        STATE_KEY,
        JSON.stringify({
          key: listingKey(),
          pages,
          scrollY: window.scrollY,
          t: Date.now(),
        })
      );
    } catch (error) {
      console.warn("NORD load-more: stav nejde uložit", error);
    }
  }

  async function fetchPage(page) {
    const response = await fetch(pageUrl(page));
    if (!response.ok) throw new Error("HTTP " + response.status);
    return response.text();
  }

  async function restore() {
    const nav = performance.getEntriesByType?.("navigation")?.[0];
    if (!nav || nav.type !== "back_forward") return;

    const state = readState();
    if (!state || state.key !== listingKey()) return;
    if (Date.now() - state.t > TTL_MS) return;

    const pageInput = document.querySelector("[data-current-page]");
    const totalInput = document.querySelector("[data-total-pages]");
    const grid = document.querySelector(".load-more-grid");
    if (!pageInput || !totalInput || !grid) return;

    const current = parseInt(pageInput.value, 10);
    const total = parseInt(totalInput.value, 10);
    const target = Math.min(state.pages, total, current + MAX_EXTRA_PAGES);
    if (!(target > current)) return;

    if ("scrollRestoration" in history) history.scrollRestoration = "manual";
    // NORD CLS: pokud prohlížeč už skočil na staré místo (kratší stránka → je vidět patička),
    // nejdřív nahoru; dočtení pod mřížkou pak proběhne mimo obrazovku (posun stránky není CLS)
    if (window.scrollY > 0) {
      try {
        window.scrollTo({ top: 0, behavior: "instant" });
      } catch (error) {
        window.scrollTo(0, 0);
      }
    }
    const buttons = document.querySelectorAll(".js-load-more");
    buttons.forEach((button) => {
      button.setAttribute("disabled", "");
      button.classList.add("loading");
    });

    try {
      const pages = [];
      for (let page = current + 1; page <= target; page++) pages.push(page);

      for (let i = 0; i < pages.length; i += CONCURRENCY) {
        const chunk = pages.slice(i, i + CONCURRENCY);
        const htmls = await Promise.all(chunk.map(fetchPage));
        htmls.forEach((html, index) => {
          const doc = new DOMParser().parseFromString(html, "text/html");
          const newGrid = doc.querySelector(".load-more-grid");
          if (!newGrid) throw new Error("Grid element not found");
          grid.insertAdjacentHTML("beforeend", newGrid.innerHTML);
          pageInput.value = chunk[index];
          if (document.getElementById("LoadMoreProgress")) {
            updateProgressLabel(html);
            updateProgressbar(chunk[index], total);
          }
        });
      }

      // tlačítko pryč ještě mimo obrazovku, ne až po posunu na místo (jinak poskočí obsah pod ním)
      if (parseInt(pageInput.value, 10) >= total) buttons.forEach((button) => button.remove());

      // NORD CLS: posun až v dalším snímku. Vložení + posun v jednom snímku prohlížeč vyhodnotí
      // jako odskok patičky (starou polohu přepočte o posun stránky) → CLS 1,0.
      await new Promise((resolve) => {
        requestAnimationFrame(() => requestAnimationFrame(resolve));
        setTimeout(resolve, 500); // skrytá karta rAF nevolá
      });

      // motiv má html { scroll-behavior: smooth } → bez „instant“ by stránka projela animací shora
      try {
        window.scrollTo({ top: state.scrollY, behavior: "instant" });
      } catch (error) {
        window.scrollTo(0, state.scrollY);
      }
    } catch (error) {
      console.error("NORD load-more: obnova načtených stran selhala", error);
    } finally {
      const loaded = parseInt(pageInput.value, 10);
      buttons.forEach((button) => {
        button.removeAttribute("disabled");
        button.classList.remove("loading");
        if (loaded >= total) button.remove();
      });
      // načtené strany navíc → ruční obnova i pro příští návrat (viz nbKeepScrollManual)
      if ("scrollRestoration" in history) history.scrollRestoration = loaded > current ? "manual" : "auto";
    }
  }

  window.addEventListener("pagehide", saveState);
  restore();
})();
